import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all English translation files
import commonEn from './locales/en/common.json';
import authEn from './locales/en/auth.json';
import dashboardEn from './locales/en/dashboard.json';
import quotationEn from './locales/en/quotation.json';
import lookupEn from './locales/en/lookup.json';
import validationEn from './locales/en/validation.json';

// Import all Spanish translation files
import commonEs from './locales/es/common.json';
import authEs from './locales/es/auth.json';
import dashboardEs from './locales/es/dashboard.json';
import quotationEs from './locales/es/quotation.json';
import lookupEs from './locales/es/lookup.json';
import validationEs from './locales/es/validation.json';

// Import all French translation files
import commonFr from './locales/fr/common.json';
import authFr from './locales/fr/auth.json';
import dashboardFr from './locales/fr/dashboard.json';
import quotationFr from './locales/fr/quotation.json';
import lookupFr from './locales/fr/lookup.json';
import validationFr from './locales/fr/validation.json';

// Import all German translation files
import commonDe from './locales/de/common.json';
import authDe from './locales/de/auth.json';
import dashboardDe from './locales/de/dashboard.json';
import quotationDe from './locales/de/quotation.json';
import lookupDe from './locales/de/lookup.json';
import validationDe from './locales/de/validation.json';

// Import all Dutch translation files
import commonNl from './locales/nl/common.json';
import authNl from './locales/nl/auth.json';
import dashboardNl from './locales/nl/dashboard.json';
import quotationNl from './locales/nl/quotation.json';
import lookupNl from './locales/nl/lookup.json';
import validationNl from './locales/nl/validation.json';

const LANGUAGE_STORAGE_KEY = 'quoteapp_language';

const getStoredLanguage = () => {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en';
  } catch {
    return 'en';
  }
};

export const supportedLanguages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'es', name: 'Spanish', nativeName: 'Español' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
  { code: 'de', name: 'German', nativeName: 'Deutsch' },
  { code: 'nl', name: 'Dutch', nativeName: 'Nederlands' },
];

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        common: commonEn,
        auth: authEn,
        dashboard: dashboardEn,
        quotation: quotationEn,
        lookup: lookupEn,
        validation: validationEn,
      },
      es: {
        common: commonEs,
        auth: authEs,
        dashboard: dashboardEs,
        quotation: quotationEs,
        lookup: lookupEs,
        validation: validationEs,
      },
      fr: {
        common: commonFr,
        auth: authFr,
        dashboard: dashboardFr,
        quotation: quotationFr,
        lookup: lookupFr,
        validation: validationFr,
      },
      de: {
        common: commonDe,
        auth: authDe,
        dashboard: dashboardDe,
        quotation: quotationDe,
        lookup: lookupDe,
        validation: validationDe,
      },
      nl: {
        common: commonNl,
        auth: authNl,
        dashboard: dashboardNl,
        quotation: quotationNl,
        lookup: lookupNl,
        validation: validationNl,
      },
    },
    lng: getStoredLanguage(),
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'auth', 'dashboard', 'quotation', 'lookup', 'validation'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    react: {
      useSuspense: false,
    },
  });

export const changeLanguage = (lang) => {
  i18n.changeLanguage(lang);
  try {
    localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
  } catch {
    // localStorage not available
  }
};

/**
 * Maps a Dataverse locale code to a supported app language code.
 * Examples: 'en-gb' → 'en', 'es-es' → 'es', 'fr-BE' → 'fr'
 */
export const mapLocaleToLanguage = (locale) => {
  if (!locale) return 'en';
  const lang = locale.toLowerCase().split('-')[0];
  const supported = supportedLanguages.map(l => l.code);
  return supported.includes(lang) ? lang : 'en';
};

export default i18n;
